import { render, staticRenderFns } from "./Youtube.vue?vue&type=template&id=218056fe&scoped=true&"
import script from "./Youtube.vue?vue&type=script&lang=js&"
export * from "./Youtube.vue?vue&type=script&lang=js&"
import style0 from "./Youtube.vue?vue&type=style&index=0&id=218056fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218056fe",
  null
  
)

export default component.exports